import { EditIcon } from '@chakra-ui/icons'
import {
  Badge,
  Box,
  Flex,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Portal,
  Text,
} from '@chakra-ui/react'
import { ActionButton } from '@components/Buttons/ActionButton'
import { PatientAllergiesModal } from '@components/Gyn/PatientAllergiesModal'
import { useProfile } from '@contexts/user/ProfileContext'
import { useMemo, useState } from 'react'
import {
  AllergyDetailBody,
  GynAllergyDisplayRow,
  getGynAllergyDisplayRows,
} from '../../allergyUtils'
import { SectionLabel } from '../../SectionLabel'

export { getGynAllergyDisplayRows }
export type { GynAllergyDisplayRow }

export const ExamAllergiesInput = () => {
  const { user, patientRef } = useProfile()
  const [allergiesModalOpen, setAllergiesModalOpen] = useState(false)
  const rows = useMemo(
    () => getGynAllergyDisplayRows(user?.gyn?.mergedData?.allergies),
    [user?.gyn?.mergedData?.allergies],
  )

  return (
    <Box data-child-name="data.allergies" w="100%" px={4} py={3}>
      <Flex w="100%" align="center" pb={1} gap={3}>
        <SectionLabel>Allergies</SectionLabel>
        <ActionButton
          size="xs"
          h={6}
          pr={3}
          pl={2}
          fontSize="xs"
          borderRadius="full"
          colorScheme="sage"
          leftIcon={<EditIcon />}
          onClick={() => setAllergiesModalOpen(true)}
          isDisabled={!patientRef}>
          Edit Allergies
        </ActionButton>
      </Flex>
      <PatientAllergiesModal
        isOpen={allergiesModalOpen}
        onClose={() => setAllergiesModalOpen(false)}
      />
      {rows.length === 0 ? (
        <Text fontSize="sm" color="gray.500">
          No documented allergies in chart.
        </Text>
      ) : (
        <Flex flexWrap="wrap" gap={2} align="center">
          {rows.map(row => (
            <Popover key={row.id} placement="bottom-start" isLazy trigger="hover">
              <PopoverTrigger>
                <Badge
                  as="button"
                  type="button"
                  px={2}
                  py={1}
                  borderRadius="md"
                  fontSize="sm"
                  cursor="pointer"
                  colorScheme="orange"
                  variant="subtle"
                  fontWeight={600}
                  textAlign="left">
                  {row.label}
                </Badge>
              </PopoverTrigger>
              <Portal>
                <PopoverContent w="280px" boxShadow="md">
                  <PopoverArrow />
                  <PopoverBody>
                    <Text fontWeight={700} fontSize="sm" mb={2}>
                      {row.label}
                    </Text>
                    <AllergyDetailBody row={row} />
                  </PopoverBody>
                </PopoverContent>
              </Portal>
            </Popover>
          ))}
        </Flex>
      )}
    </Box>
  )
}
